import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [u, setU] = useState({ username: '', password: '', role: 'office' });
  const [pct, setPct] = useState('');
  const [msg, setMsg] = useState('');
  const [audit, setAudit] = useState([]);
  const [auditMsg, setAuditMsg] = useState('');

  const load = () => api.get('/api/users').then(r => setUsers(r.data || [])).catch(() => setUsers([]));
  const loadAudit = () => api.get('/api/parts/price-audit').then(r => setAudit(r.data || [])).catch(() => setAudit([]));
  useEffect(() => { load(); loadAudit(); }, []);

  const undoAudit = async (id) => {
    if (!window.confirm('Are you sure you want to undo this price change?')) return;
    setAuditMsg('');
    try {
      const { data } = await api.post(`/api/parts/price-undo/${id}`);
      setAuditMsg(`Undid audit #${id} — restored ${data.parts_restored} parts and ${data.tiers_restored} tiers.`);
      loadAudit();
    } catch {
      setAuditMsg('Failed to undo price change.');
    }
  };

  const addUser = async (e) => {
    e.preventDefault();
    setMsg('');
    try { await api.post('/api/users', u); setU({ username: '', password: '', role: 'office' }); load(); setMsg('User added.'); }
    catch { setMsg('Failed to add user.'); }
  };

  const applyIncrease = async () => {
    if (!pct) return;
    const n = Number(pct);
    const verb = n < 0 ? 'decrease' : 'increase';
    if (!window.confirm(`Apply ${Math.abs(n)}% ${verb} to all pricing tiers?`)) return;
    try {
      const { data } = await api.post('/api/parts/price-increase', { percentage: n });
      setMsg(`Applied ${Math.abs(n)}% ${verb} to ${data.tiers_updated} pricing tiers.`);
      setPct('');
    } catch { setMsg('Failed to apply increase.'); }
  };

  return (
    <div>
      <h2>Admin</h2>
      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>Users</h3>
        <table>
          <thead><tr><th>Username</th><th>Role</th></tr></thead>
          <tbody>{users.map(x => <tr key={x.id}><td>{x.username}</td><td>{x.role}</td></tr>)}</tbody>
        </table>
        <form onSubmit={addUser} style={{ marginTop: 12 }}>
          <div className="grid2">
            <div className="field"><label>Username</label><input value={u.username} onChange={e => setU({ ...u, username: e.target.value })} required /></div>
            <div className="field"><label>Password</label><input type="password" value={u.password} onChange={e => setU({ ...u, password: e.target.value })} required /></div>
            <div className="field"><label>Role</label>
              <select value={u.role} onChange={e => setU({ ...u, role: e.target.value })}>
                <option value="admin">admin</option><option value="office">office</option><option value="shop_floor">shop_floor</option>
              </select>
            </div>
          </div>
          <button className="btn-success" type="submit">+ Add User</button>
        </form>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Global Price Adjustment</h3>
        <p>Apply a percentage change to every pricing tier across all parts. Use a negative value to decrease.</p>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', maxWidth: 360 }}>
          <input type="number" step="0.01" placeholder="Percent (e.g. 5 or -5)" value={pct} onChange={e => setPct(e.target.value)} />
          <button className="btn-orange" onClick={applyIncrease}>Apply</button>
        </div>
      </div>
      {msg && <div style={{ marginTop: 12, color: '#1a3a5c' }}>{msg}</div>}

      <div className="card" style={{ marginTop: 16 }}>
        <h3 style={{ marginTop: 0 }}>Global Price History</h3>
        <table>
          <thead>
            <tr><th>Date</th><th>Username</th><th>Notes</th><th>Status</th><th>Action</th></tr>
          </thead>
          <tbody>
            {audit.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: '#888', padding: 12 }}>No global price changes yet.</td></tr>
            )}
            {audit.map(a => (
              <tr key={a.id}>
                <td>{new Date(a.created_at).toLocaleString()}</td>
                <td>{a.username || '—'}</td>
                <td>{a.notes}</td>
                <td>{a.already_undone ? 'Undone' : ''}</td>
                <td>{!a.already_undone && <button onClick={() => undoAudit(a.id)}>Undo</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {auditMsg && <div style={{ marginTop: 12, color: '#1a3a5c' }}>{auditMsg}</div>}
      </div>
    </div>
  );
}
